import { ifyouApi, kevinAuthAPI, STORY } from 'apis/config';
import ErrorMessage from 'apis/ErrorMessage';

export const characterList = async (projectId) => {
  try {
    const res = await ifyouApi.post(`${STORY}/${projectId}/model-list`);
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

export const characterSlaveList = async (projectId, modelId) => {
  try {
    const res = await ifyouApi.post(`${STORY}/${projectId}/model-slave-list`, {
      model_id: modelId,
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

export const characterRegister = async (projectId, inputData) => {
  try {
    const res = await ifyouApi.post(`${STORY}/${projectId}/model-register`, {
      model_type: inputData.model_type,
      model_name: inputData.model_name,
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

export const characterDelete = async (projectId, modelId) => {
  try {
    const res = await ifyouApi.post(
      `${STORY}/${projectId}/model-master-delete`,
      {
        model_id: modelId,
      },
    );
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

export const characterUpdate = async (projectId, inputData) => {
  try {
    const res = await ifyouApi.post(
      `${STORY}/${projectId}/model-master-update`,
      {
        model_id: inputData.model_id,
        model_name: inputData.model_name,
        offset_x: inputData.offset_x,
        offset_y: inputData.offset_y,
        game_scale: inputData.game_scale,
        direction: inputData.direction,
      },
    );
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

export const characterReset = async (projectId, modelId) => {
  try {
    const res = await ifyouApi.post(
      `${STORY}/${projectId}/model-motion-clear`,
      {
        model_id: modelId,
      },
    );
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

export const characterSlaveUpdate = async (projectId, record, inputData) => {
  try {
    const res = await ifyouApi.post(
      `${STORY}/${projectId}/model-motion-update`,
      {
        model_id: record.model_id,
        file_key: record.file_name,
        motion_name: inputData.motion_name,
      },
    );
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

export const characterSlaveDelete = async (projectId, inputData) => {
  try {
    const res = await ifyouApi.post(
      `${STORY}/${projectId}/model-motion-delete`,
      {
        model_id: inputData.model_id,
        file_key: inputData.file_key,
      },
    );
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

export const characterZipUpload = async (projectId, formData) => {
  try {
    const res = await ifyouApi.post(
      `${STORY}/${projectId}/live2d-model-upload`,
      formData,
      {
        header: { 'Content-Type': 'multipart/form-data' },
      },
    );
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

export const characterApis = {
  list: (projectId) =>
    kevinAuthAPI
      .get(`/common/project/${projectId}/character/-1`)
      .then((res) => res.data)
      .catch((err) => console.log(err)),
};
